module.exports = __webpack_public_path__ + "images/concept_kr4_focus.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/concept/concept_kr4_focus.png
// module id = 749
// module chunks = 0